import classNames from 'classnames/bind';
import React from 'react';
import { Popup as SemanticUiPopup, PopupProps as SemanticUiPopupProps } from 'semantic-ui-react';
import styles from './Tooltip.module.scss';
import { TooltipPosition } from './TooltipPosition.enum';

const cx = classNames.bind(styles);

interface TooltipProps extends SemanticUiPopupProps {
  position?: TooltipPosition;
}

const POPPER_MODIFIERS = [
  {
    name: 'flip',
    enabled: true,
    options: {
      fallbackPlacements: ['left', 'right', 'bottom'],
    },
  },
];

const Tooltip = ({
  trigger,
  position = TooltipPosition.TopCenter,
  content,
  disabled,
  hideOnScroll = true,
  offset = [0, 1],
  children,
  ...rest
}: TooltipProps): React.ReactElement => {
  return (
    <SemanticUiPopup
      className={cx('body')}
      disabled={disabled}
      trigger={trigger || children}
      position={position}
      content={content}
      popperModifiers={POPPER_MODIFIERS}
      hideOnScroll={hideOnScroll}
      offset={offset}
      {...rest}
    />
  );
};

export default Tooltip;
